import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import styles from '@patternfly/react-styles/css/components/NotificationDrawer/notification-drawer.mjs';
import { css } from '@patternfly/react-styles';
export const NotificationDrawerBody = (_a) => {
    var { children, className = '' } = _a, props = __rest(_a, ["children", "className"]);
    return (_jsx("div", Object.assign({}, props, { className: css(styles.notificationDrawerBody, className), children: children })));
};
NotificationDrawerBody.displayName = 'NotificationDrawerBody';
//# sourceMappingURL=NotificationDrawerBody.js.map